// @flow

import type { BasicProps } from '../../type'

import * as React from 'react'
import { appendPropsActions, prependPropsSchema } from '../util/schemaUtil'

export default function (includeData: boolean, annotation?: string) {
  return function (WrappedComponent: React.ComponentType<BasicProps>) {
    class AfterCompute extends React.PureComponent<*> {
      static actions = appendPropsActions(WrappedComponent);
      static schema = [
        ...prependPropsSchema(WrappedComponent, [
          {
            type: 'printContext',
            includeData,
            annotation
          }
        ]),
        ...[
          'separator',
          {
            type: 'analysis'
          }
        ]
      ];

      wrappedComponent: ?React.Component<*>;

      actionPrintContext = () => {
        console.log(this.props.jsEnv.getContext())
      };

      render () {
        return (
          <WrappedComponent
            ref={ref => {
              if (ref) {
                this.wrappedComponent = ref
              }
            }}
            {...this.props}
          />
        )
      }
    }

    return AfterCompute
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/afterComputeData.js